import { CommonModule } from '@angular/common';
import { Component, Renderer2, ElementRef, OnInit } from '@angular/core';
import { MatDialog} from '@angular/material/dialog';
import { AuthService } from '@auth0/auth0-angular';
import { Store } from '@ngrx/store';
import { AuthState } from '../state/auth/auth.state';
import { getUserLogin } from '../state/auth/auth.selectors';
import { AuthActions } from '../state/auth';
import { RouterLink } from '@angular/router';
import { Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { NotificationBannerComponent } from '../notification-banner/notification-banner.component';
import { PaymentPopupComponent } from '../payment-popup/payment-popup.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink, NotificationBannerComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})

export class HeaderComponent implements OnInit {
  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private authService: AuthService,
    private store: Store<AuthState>,
    private viewportScroller: ViewportScroller,
    private router: Router,
    private dialog: MatDialog
  ) { }

  isUserLoggedIn = false;

  login(url: string) {
    this.store.dispatch(AuthActions.login());
    this.authService.isAuthenticated$.subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this.router.navigate([url]);
      }
    })
  }

  logout() {
    this.store.dispatch(AuthActions.logout());
  }

  signUp(url: string) {
    this.store.dispatch(AuthActions.signup());
    this.authService.isAuthenticated$.subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this.router.navigate([url]);
      }
    });
  }

  openDialogAndRedirectOnClose(): void {
      const dialogRef = this.dialog.open(PaymentPopupComponent, {
        width: '700px',
        data: {
          title: "IMPORTANT MESSAGE"
        },
        disableClose: true
      });

      dialogRef.afterClosed().subscribe((result) => {
        window.open('https://3282543.ecommerce.zuora.com/auth/auth0', '_blank');
      });
    }

  navigateToBilling() {
    this.openDialogAndRedirectOnClose();
  }

  toggleMenu() {
    const menu = document.getElementById('menu');
    if (menu) {
      menu.classList.toggle('active');

      const innerMenuSection1 = document.querySelector('.inner-menu-section1');
      const innerMenuSection2 = document.querySelector('.inner-menu-section2');
      const innerMenuSection3 = document.querySelector('.inner-menu-section3');
      const innerMenuSection4 = document.querySelector('.inner-menu-section4');
      const innerMenuSection5 = document.querySelector('.inner-menu-section5');

      if (innerMenuSection1)
        innerMenuSection1.classList.toggle('slideDownAnimation');
      if (innerMenuSection2)
        innerMenuSection2.classList.toggle('slideUpAnimation');
      if (innerMenuSection3)
        innerMenuSection3.classList.toggle('slideDownAnimation');
      if (innerMenuSection4)
        innerMenuSection4.classList.toggle('slideUpAnimation');
      if (innerMenuSection5)
        innerMenuSection5.classList.toggle('slideDownAnimation');
    }
  }

  ngAfterViewInit(): void {
    const dropdownToggles = this.el.nativeElement.querySelectorAll(
      '.inner-section-dropdown'
    );

    dropdownToggles.forEach((toggle: HTMLElement) => {
      this.renderer.listen(toggle, 'click', (event: Event) => {
        event.preventDefault();

        // Hide all dropdown menus
        const allDropdownMenus =
          this.el.nativeElement.querySelectorAll('.dropdown-menu');
        allDropdownMenus.forEach((menu: HTMLElement) => {
          this.renderer.setStyle(menu, 'display', 'none');
        });

        // Toggle the clicked dropdown menu
        const dropdownMenu = toggle.nextElementSibling as HTMLElement;
        if (dropdownMenu.style.display === 'block') {
          this.renderer.setStyle(dropdownMenu, 'display', 'none');
          dropdownMenu.classList.remove('fadeInAnimation');
        } else {
          this.renderer.setStyle(dropdownMenu, 'display', 'block');
          dropdownMenu.classList.add('fadeInAnimation');
        }
      });
    });
  }

  ngOnInit() {
    this.viewportScroller.scrollToPosition([0, 0]);
    this.authService.isAuthenticated$.subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this.store.dispatch(AuthActions.loginSuccess());
      }
    });

    this.store
      .select(getUserLogin)
      .subscribe((userLogin) => (this.isUserLoggedIn = userLogin));
  }
}


